import * as React from 'react';
import styles from './Wallet.scss';
import { t } from '~/utils/localization';
import { useDispatch } from 'react-redux';
import { WalletPopup } from '~/components/Wallet/Wallet';
import { scrollMobileContainer } from '~/utils/scrollTop';
import { appActions } from '~/Store/appSlice';
import { RootState, useAppSelector } from '~/Store';
import equal from 'fast-deep-equal/react';
import { useNavigate } from 'react-router-dom';
import { urlsMap } from '~/utils/menu';

const stateSelector = (state: RootState) => {
    return {
        id: state.account.id,
    };
};

const MobileWalletCategory = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const account = useAppSelector(stateSelector, equal);

    React.useEffect(() => {
        if (!account.id) {
            navigate(urlsMap.home);
            return;
        }

        scrollMobileContainer({ top: 0 });
        dispatch(
            appActions.changeCurrentPage({
                title: t('Кошелёк'),
                name: 'wallet',
                isBundlePage: false,
            }),
        );
    }, []);

    if (!account.id) {
        return null;
    }

    return (
        <div className={styles.walletContainer}>
            <WalletPopup callback={() => null} />
        </div>
    );
};

export default MobileWalletCategory;
